export default __webpack_public_path__ + "static/media/film2.e30836f4.jpg";